// extracted by mini-css-extract-plugin
module.exports = {"RatingControler":"RatingController_RatingControler__2zcE9","RatingControler-Title":"RatingController_RatingControler-Title__14Zi8"};